<template>
    <div v-if="isLoaded" class="tooltip-container">
        <!-- ✅ แก้ — spinner เฉพาะตอนกำลังโหลดจริง (เดิมหมุนค้างตลอดไปถ้าร้านไม่มีเอกสาร subscription) -->
        <ButtonLoading v-show="!subscription?.name && subscriptionLoading" />
        <div v-if="!subscription?.name && !subscriptionLoading" class="tooltip-header">
            <h3 class="tooltip-title">ยังไม่มีแพ็กเกจ</h3>
            <router-link :to="`/dashboard/${$route.params.id}/package`">เลือกแพ็กเกจ</router-link>
        </div>

        <!-- Title -->
        <div class="tooltip-header" v-if="subscription?.name">

            <div class="d-flex justify-content-between">
                <div>
                    <h3 class="tooltip-title">{{ subscription?.name }}</h3>

                    <p class="tooltip-expire" :class="{ expired: isExpired(subscription?.creditLastReset) }">

                        <span v-if="isExpired(subscription?.creditLastReset)"
                            style="display: flex; align-items: center;">
                            <span class="material-symbols-outlined">
                                hourglass_bottom
                            </span> หมดอายุแล้ว
                        </span>

                        <span v-else style="display: flex; align-items: center;">

                            <span class="material-symbols-outlined">
                                hourglass_top
                            </span>เหลือ {{ remainingDays(subscription?.creditLastReset) }} วัน
                        </span>
                    </p>
                </div>
                <div class="tooltip-footer" v-if="!fullScreen">
                    <button class="btn tooltip-upgrade-btn" @click="onUpgrade">
                        อัปเกรดแพ็กเกจ →
                    </button>
                </div>
            </div>
        </div>

        <!-- Reset Date -->
        <div class="tooltip-body" v-if="subscription?.name">
            <div class="expire-box" :class="{ 'expire-box-expired': isExpired(subscription?.creditLastReset) }">
                <div class="expire-label">วันที่เริ่มนับรอบ</div>
                <div class="expire-value">{{ formatDate(subscription?.creditLastReset) }}</div>
            </div>
        </div>

        <!-- Footer -->

    </div>
</template>

<script>
import ButtonLoading from "@/components/ButtonLoading.vue";

export default {
    name: "PackageCardTooltip",
    components: { ButtonLoading },

    props: {
        visible: { type: Boolean, default: false },
        fullScreen: { type: Boolean, default: false }
    },

    async mounted() {
        const pageData = this.$storex.getters.getPageData;
        if (!pageData || !pageData.id) return;

        this.isLoaded = true;
    },

    data() {
        return {
            expanded: false,
            isLoaded: false
        };
    },

    computed: {
        subscriptionLoading() {
            const st = this.$storex.getters["subscriptionModule/getSubscriptionStatus"];
            return st === "idle" || st === "loading";
        },
        subscription() {
            return this.$storex.getters["subscriptionModule/getSubscription"];
        },
    },

    methods: {
        formatDate(ts) {
            return new Date(ts).toLocaleString("th-TH", {
                dateStyle: "medium",
                timeStyle: "short"
            });
        },
        remainingDays(ts) {
            const now = Date.now();
            const diff = now - Number(ts || 0);
            const THIRTY = 30 * 24 * 60 * 60 * 1000;

            if (diff >= THIRTY) return 0;

            return Math.ceil((THIRTY - diff) / (24 * 60 * 60 * 1000));
        },
        isExpired(creditLastReset) {
            const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
            return Date.now() - Number(creditLastReset || 0) > THIRTY_DAYS;
        },
        onUpgrade() {
            const pageData = this.$storex.getters.getPageData;
            this.$router.push(`/dashboard/${pageData.id}/package`);
        }
    }
};
</script>



<style scoped>
/* === Animation === */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.tooltip-container {
    animation: fadeIn 0.25s ease;
    position: relative;
    height: 140px;
}

.tooltip-header {
    /* margin-bottom: 1rem; */
}

.tooltip-title {
    font-size: 1rem;
    font-weight: 700;
    color: #111;
    margin: 0;
}

.tooltip-expire {
    font-size: 0.8rem;
    margin-top: 4px;
    color: #059669;
    /* เขียว */
    font-weight: 500;
}

.tooltip-expire.expired {
    color: #dc2626;
    /* แดง */
    font-weight: 600;
}

/* Box ของวันเริ่มต้น */
.expire-box {
    padding: 0.75rem;
    background: #f1f5f9;
    border-radius: 10px;
    /* border-left: 4px solid #3b82f6; */
    margin-bottom: 1rem;
}

.expire-box-expired {
    border-left-color: #dc2626;
    background: #fee2e2;
}

.expire-label {
    font-size: 0.75rem;
    color: #64748b;
}

.expire-value {
    font-size: 0.85rem;
    font-weight: 600;
    color: #334155;
    margin-top: 2px;
}

.tooltip-footer {
    text-align: center;
}

.tooltip-upgrade-btn {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 6px 10px;
    color: #2563eb;
    border-radius: 6px;
    background: #eff6ff;
    border: 1px solid transparent;
    transition: 0.2s ease;
}

.tooltip-upgrade-btn:hover {
    background: #dbeafe;
    border-color: #93c5fd;
    text-decoration: none;
}
</style>